import { render, staticRenderFns } from "./TagAddDialog.vue?vue&type=template&id=153bed2e"
import script from "./TagAddDialog.vue?vue&type=script&lang=js"
export * from "./TagAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports